// extracted by mini-css-extract-plugin
export default {"changeButton":"changeMenu__changeButton-gHzzg"};